/**
 * Testimonials Carousel
 *
 * This component requires jQuery and Slick to function.
 * You can require it on the page using <div data-component="testimonials-carousel"></div>
 */
import 'slick-carousel';
$(function () {
  $('[data-component="testimonials-carousel"]').each(function () {
    let $holder = $(this);
    let $more = $('.js-more-testimonial');
    $holder.slick({
      rows: 0,
      dots: true,
      infinite: true,
      arrows: true,
      prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><i class="icon-left-arrow"></i></button>',
      nextArrow: '<button class="slick-next" aria-label="Next" type="button"><i class="icon-right-arrow"></i></button>',
      slidesToShow: 2,
      slidesToScroll: 1,
      focusOnSelect: true,
      focusOnChange: true,
      centerMode: true,
      centerPadding: '0',
      responsive: [{
        breakpoint: 992,
        settings: {
          arrows: false,
          centerMode: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: true
        }
      }, {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: true
        }
      }]
    });
    $more.click(function (e) {
      e.preventDefault();
      $(this).parent().addClass('is-active');
    });
  });
});